import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditleadComponent } from './editlead.component';
import { AppAgentComponent } from './app-agent/app-agent.component';
import { AppContentAgentComponent } from './app-content-agent/app-content-agent.component';


const routes: Routes = [
  {path : '' , component : AppAgentComponent , children : [ { path: 'editlead', component:EditleadComponent },
   { path:'' , component : AppContentAgentComponent}]} ,
  
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  
})
export class UserRoutingModule { }
